import * as React from 'react';
import { EGDSPrimaryButton, EGDSTertiaryButton } from '@egds/react-core/button';
import { EGDSIcon } from '@egds/react-core/icons';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { useGridViewContext } from '@shared-ui/lodging-property-listing';
const ButtonItem = ({
  onClick,
  toggled,
  iconName,
  name
}) => toggled ? React.createElement(EGDSPrimaryButton, {
  type: "button",
  id: `${name}-toggle`,
  "aria-label": `${name}, selected`
}, React.createElement(EGDSIcon, {
  name: iconName
})) : React.createElement(EGDSTertiaryButton, {
  type: "button",
  onClick: onClick,
  id: `${name}-toggle`,
  "aria-label": `${name}, unselected`
}, React.createElement(EGDSIcon, {
  name: iconName
}));
export const GridViewToggle = ({
  alignment = 'end'
}) => {
  const {
    isGridView,
    toggleGridView
  } = useGridViewContext();
  return React.createElement(Experiment, {
    name: "SRP_Grid_view_web"
  }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSLayoutFlex, {
    direction: "row",
    justifyContent: alignment,
    space: "one",
    alignItems: 'center'
  }, React.createElement(EGDSLayoutFlexItem, null, React.createElement(ButtonItem, {
    onClick: toggleGridView,
    toggled: !isGridView,
    iconName: 'view_list',
    name: 'list-view'
  })), React.createElement(EGDSLayoutFlexItem, null, React.createElement(ButtonItem, {
    onClick: toggleGridView,
    toggled: isGridView,
    iconName: 'view_grid_large',
    name: 'grid-view'
  })))));
};